(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["natura-contact"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('natura-contact')) {
    customElements.define('natura-contact', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.details = this.querySelector('details');
        this.launcher = this.querySelector('summary');
        this.panel = this.querySelector('[role="dialog"]');
        this.chatLink = this.querySelector('[data-contact-chat]');
        this.querySelector('[data-contact-close]').hidden = false;
        this.querySelector('[data-contact-close]').addEventListener('click', () => this.close(true), options);
        this.details.addEventListener('toggle', () => {
          this.launcher.setAttribute('aria-expanded', String(this.details.open));
          if (this.details.open) {
            this.connectChat();
            this.panel.focus({ preventScroll: true });
          }
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.details.open) {
            event.preventDefault();
            event.stopPropagation();
            this.close(true);
          }
        }, options);
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(false);
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (this.details.open && !event.composedPath().includes(this)) this.close(false);
        }, options);
        this.chatLink.addEventListener('click', (event) => {
          this.connectChat();
          const activator = this.getChatActivator();
          if (!activator) return;
          event.preventDefault();
          this.restoreAfterChat = true;
          this.close(false);
          if (!this.chat.hasAttribute('open')) activator.click();
        }, options);
        this.purchaseBar = document.querySelector('.natura-mobile-purchase');
        if (this.purchaseBar) {
          this.purchaseObserver = new ResizeObserver(() => this.positionAbovePurchase());
          this.purchaseObserver.observe(this.purchaseBar);
          this.purchaseVisibility = new MutationObserver(() => this.positionAbovePurchase());
          this.purchaseVisibility.observe(this.purchaseBar, { attributes: true, attributeFilter: ['hidden', 'class'] });
          this.positionAbovePurchase();
        }
        this.connectChat();
        if (!this.chat) {
          let attempts = 0;
          this.chatTimer = setInterval(() => {
            this.connectChat();
            if (this.chat || ++attempts >= 30) clearInterval(this.chatTimer);
          }, 1000);
        }
      }
      getChatActivator() {
        const host = document.querySelector('shopify-chat');
        const root = host?.shadowRoot;
        return root?.querySelector('button[part~="activator"]') || root?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('button[part~="activator"]');
      }
      connectChat() {
        if (this.chat?.isConnected) return;
        if (!this.getChatActivator()) return;
        this.chat = document.querySelector('shopify-chat');
        this.chat.setAttribute('data-natura-contact-integrated', '');
        this.querySelector('[data-contact-chat-label]').textContent = this.dataset.chatLabel;
        this.querySelector('[data-contact-chat-note]').textContent = this.dataset.chatNote;
        this.chatObserver?.disconnect();
        this.chatObserver = new MutationObserver(() => {
          const open = this.chat.hasAttribute('open');
          this.hidden = open;
          if (open) this.close(false);
          else if (this.restoreAfterChat) {
            this.restoreAfterChat = false;
            this.launcher.focus({ preventScroll: true });
          }
        });
        this.chatObserver.observe(this.chat, { attributes: true, attributeFilter: ['open'] });
        this.hidden = this.chat.hasAttribute('open');
      }
      positionAbovePurchase() {
        const height = this.purchaseBar.hidden ? 0 : this.purchaseBar.getBoundingClientRect().height;
        this.style.setProperty('--natura-contact-obstacle', `${Math.ceil(height)}px`);
      }
      close(restoreFocus) {
        this.details.open = false;
        if (restoreFocus) this.launcher.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.abort?.abort();
        clearInterval(this.chatTimer);
        this.purchaseObserver?.disconnect();
        this.purchaseVisibility?.disconnect();
        this.chatObserver?.disconnect();
        this.chat?.removeAttribute('data-natura-contact-integrated');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
